// extracted by mini-css-extract-plugin
export default {"course_wp":"CourseItem_course_wp__E6M3e","course_bg":"CourseItem_course_bg__EdZLo","course_text":"CourseItem_course_text__oSBXX"};